// extracted by mini-css-extract-plugin
export var blogCard = "blog-module--blog-card--edbf8";
export var chaptersLinkContainer = "blog-module--chapters-link-container--2ee92";